(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('global-approval-policy', {
            parent: 'entity',
            url: '/global-approval-policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageglobalapprovalpolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy.html',
                    controller: 'GlobalApprovalPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('globalApprovalPolicy');
                    $translatePartialLoader.addPart('globalEntityActionApprovalPolicy');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('global-approval-policy.new', {
            parent: 'global-approval-policy',
            url: '/global-approval-policy/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                            return { id:null };
                        }],
                        mode: function(){
                       	 return "New";
                        }
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', {}, { reload: 'global-approval-policy' });
                }, function() {
                    $state.go('global-approval-policy');
                });
            }]
        })
        .state('global-approval-policy.edit', {
            parent: 'global-approval-policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                                     return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "Edit";
                                 }
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', {}, { reload: true });
                }, function() {
                    $state.go('global-approval-policy');
                });
            }]
            
        })
        .state('global-approval-policy.view', {
            parent: 'global-approval-policy',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                                     return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "View";
                                 }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('global-approval-policy.delete', {
            parent: 'global-approval-policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-delete-dialog.html',
                    controller: 'GlobalApprovalPolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                            return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('global-approval-policy-todolist', {
            parent: 'dashboard',
            url: '/global-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        mode: function(){
                       	 return "";
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('globalApprovalPolicy');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-approval-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/global-approval-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                        	

                        },
                        mode: function(){
                          	 return "";
                           },
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('error');
                           $translatePartialLoader.addPart('global');
                           $translatePartialLoader.addPart('globalApprovalPolicy');
                           return $translate.refresh();
                       }]
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
        .state('global-approval-policy.map', {
            parent: 'global-approval-policy',
            url: '/global-entity-action-approval-policy/{id}/map',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-entity-action-approval-policy.html',
                    controller: 'GlobalEntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: ['GlobalEntityActionApprovalPolicy', 'GlobalValues', function(GlobalEntityActionApprovalPolicy, GlobalValues) {
                    		return GlobalEntityActionApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', {}, { reload: 'global-approval-policy' });
                }, function() {
                    $state.go('global-approval-policy');
                });
            }]
        })
        .state('global-entity-action-approval-policy-view', {
            parent: 'global-entity-action-approval-policy-todolist',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-approval-policy-dialog.html',
                    controller: 'GlobalApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                            	 entity: ['GlobalApprovalPolicy', 'GlobalValues', function(GlobalApprovalPolicy, GlobalValues) {
                                     return GlobalApprovalPolicy.get({orgId:GlobalValues.getOrgId(), id:$stateParams.id}).$promise;
                                 }],
                                 mode: function(){
                                	 return "View";
                                 }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         .state('global-entity-action-approval-policy-todolist', {
            parent: 'dashboard',
            url: '/global-entity-action-approval-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-entity-action-approval-policy.html',
                    controller: 'GlobalEntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('globalApprovalPolicy');
                            $translatePartialLoader.addPart('globalEntityActionApprovalPolicy');                       
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                	$state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-entity-action-approval-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/global-entity-action-approval-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-approval-policy/global-entity-action-approval-policy.html',
                    controller: 'GlobalEntityActionApprovalPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                        	

                        },
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                           $translatePartialLoader.addPart('error');
                           $translatePartialLoader.addPart('global');
                           $translatePartialLoader.addPart('globalApprovalPolicy');
                           $translatePartialLoader.addPart('globalEntityActionApprovalPolicy');
                           return $translate.refresh();
                       }]
                    }
                }).result.then(function() {
                    $state.go('global-approval-policy', null, { reload: 'global-approval-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
   };
})();